/** Tab-local selection. Only the backend determines the club modality and ownership. */
export interface ClubContext {
  mode: 'GLOBAL' | 'PRIVATE'; clubId: string; ownerUserId: string;
  privateLeagueId: string | null; seasonId: string | null; competitionUnitId: string | null;
}
export interface ClubCapabilities {
  clubId: string; productEnabled: boolean; play: boolean;
  actions: Record<string, { available: boolean; reason: string | null }>;
}
const selectionKey = 'lom.selected-club.v1';
let context: ClubContext | null = null;
let capabilities: ClubCapabilities | null = null;
export function selectedClubId(): string | null {
  return typeof sessionStorage === 'undefined' ? null : sessionStorage.getItem(selectionKey);
}
export function selectClub(clubId: string): void {
  sessionStorage.setItem(selectionKey, clubId);
  context = null; capabilities = null;
}
export function clearClubSelection(): void {
  if (typeof sessionStorage !== 'undefined') sessionStorage.removeItem(selectionKey);
  context = null; capabilities = null;
}
export function confirmClub(value: ClubContext, gates: ClubCapabilities): void {
  if (value.clubId !== selectedClubId() || gates.clubId !== value.clubId) throw new Error('El club seleccionado ha cambiado.');
  context = value; capabilities = gates;
}
export function confirmedClub(): ClubContext | null { return context; }
export function clubCapabilities(): ClubCapabilities | null { return capabilities; }
export function clubPath(suffix = '', clubId = selectedClubId()): string {
  if (!clubId) throw new Error('Selecciona un club para continuar.');
  return `/api/clubs/${encodeURIComponent(clubId)}${suffix}`;
}
/** Cached presentation and drafts never cross clubs or browser tabs. */
export const clubStorage = {
  getItem(key: string): string | null { return typeof sessionStorage === 'undefined' ? null : sessionStorage.getItem(`lom.club.${selectedClubId() || 'none'}.${key}`); },
  setItem(key: string, value: string): void { sessionStorage.setItem(`lom.club.${selectedClubId() || 'none'}.${key}`, value); },
  removeItem(key: string): void { sessionStorage.removeItem(`lom.club.${selectedClubId() || 'none'}.${key}`); },
};
